import { AxiosInstance } from './axios.core';

import { API_URL } from './api.base';

import { ListResponseModel, ListRuquestModel, OrganizationNodepProps, TagProps, UserProps } from './models';

export const createAccount = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/accounts`, { ...params });
}

export const getAccount = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/account`, {});
}

export const getOrganizationList = (): Promise<OrganizationNodepProps[]> => {
  return AxiosInstance.get(`${API_URL}/organizations`, {});
}

export const getOrganizationTree = (): Promise<OrganizationNodepProps[]> => {
  return AxiosInstance.get(`${API_URL}/organizations/tree`, {});
}

export const addOrganization = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/organizations`, { ...params });
}

export const deleteOrganization = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/organizations/${id}`);
}


export const addTag = (params: TagProps): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/tags`, { ...params });
}

export const getTags = (params: ListRuquestModel): Promise<ListResponseModel<TagProps>> => {
  return AxiosInstance.get(`${API_URL}/tags`, { params });
}

export const getTagList = (): Promise<TagProps[]> => {
  return AxiosInstance.get(`${API_URL}/tags/list?isAll=true`);
}

export const getTagListByStatic = (): Promise<TagProps[]> => {
  return AxiosInstance.get(`${API_URL}/tags/list?isAll=false`);
}

export const getTag = (id: string): Promise<TagProps> => {
  return AxiosInstance.get(`${API_URL}/tags/${id}`);
}

export const getAccountPlatforms = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/account/deviceplatforms`);
}

export const deleteTag = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/tags/${id}`);
}

export const getTagaDeviceList = (id: string, params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/tagValues/${id}/devices`, { params });
}

export const addUser = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/users`, { ...params });
}

export const getUserList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/users`, { params });
}

export const getAllUserList = (): Promise<UserProps[]> => {
  return AxiosInstance.get(`${API_URL}/users/list`);
}

export const getUser = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/users/${id}`);
}

export const deleteUser = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/users/${id}`);
}

export const importUsers = (_params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key])
  }
  return AxiosInstance.post(`${API_URL}/users/import`, params);
}

export const getOverview = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/overview`);
}
export const getAccountList = (params: any): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/managers`, { params });
}
export const registerManager = (params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/managers/register`, params);
}
export const addManager = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/managers`, { ...params });
}
export const deleteManager = (account: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/managers/${account}`);
}
export const getTenants = (params: any): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/tenants`, {params });
}
export const getTenantList = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/tenants/list`, {params });
}
export const addTenant = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/tenants`, { ...params });
}
export const deleteTenant = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/tenants/${id}`);
}
export const swichTenant = (id: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/tenants/${id}/switch`);
}

export const getTenantScopes = (params:any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/tenant/scopes`,{params});
}
export const getTenantScopesAccount = (accountName: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/tenant/scopes/account/${accountName}`, {params});
}
export const deleteTenantScopesAccount = (accountName: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/tenant/scopes/account/${accountName}`);
}
export const addTenantScopes = (params:any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/tenant/scopes`,params);
}
export const getTenantTags = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/tenants/tags`);
}
export const addTrial=(params:any): Promise<any> => {

  return AxiosInstance.put(`${API_URL}/trial`,params);
}

export const getPlatformLog = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/Platform/operations`, {params});
}

export const getOptionsLog = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/operations`, {params});
}
export const exportDeviceLog = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/operations/export`, { params, responseType: 'blob' });
}
export const exportPlatformLog = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/Platform/operations/export`, { params, responseType: 'blob' });
}
export const getOptionsType = (platform: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/opeations/types/${platform}`);
}

export const getClassRooms = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/classrooms`, {params});
}
export const putClassRooms = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/classrooms`, params);
}
export const deleteClassRooms = (roomId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/classrooms/${roomId}`);
}

export const getClassRoomsDevices = (roomId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/classrooms/${roomId}/devices`, {params});
}
export const getUnselectDevices = (roomId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/classrooms/${roomId}/devices/unselected`, {params});
}
export const addClassRoomsDevices = (roomId: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/ios/settings/classrooms/${roomId}/devices`, params);
}
export const deleteClassRoomsDevices = (roomId: string, params: any): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/classrooms/${roomId}/devices`, {params});
}
// export const applyClassRoomsDevices = (roomId: string): Promise<any> => {
//   return AxiosInstance.post(`${API_URL}/apns/classrooms/${roomId}/apply`);
// }
export const applyProfile = (): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/apns/classrooms/apply`);
}

export const applySingleProfile = (roomId: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/apns/classrooms/${roomId}/apply`);
}

export const getRoles = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/rabc/roles`, { params });
}

export const getRolesList = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/rabc/roles/list`);
}

export const getMenuList = (): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/rabc/modules`);
}

export const postRoles = (params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/rabc/roles`, params);
}

export const deleteRoleByID = (roleId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/rabc/roles/${roleId}`);
}

export const emaillogin=(params:any): Promise<any> => {

  return AxiosInstance.post(`${API_URL}/accounts/emails/login`,params);
}

export const sendEmailCode=(email:string, isRegister:boolean): Promise<any> => {

  return AxiosInstance.get(`${API_URL}/accounts/emails/code?email=${email}&isRegister=${isRegister}`);
}

export const emailRegister=(_params:any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }

  return AxiosInstance.put(
    `${API_URL}/accounts/emails/register`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
}

export const resetPwdByEmail=(params:any): Promise<any> => {

  return AxiosInstance.post(`${API_URL}/accounts/emails/resetpwd`,params);
}

export const resetPwdByManager = (params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/managers/resetpwd`, params);
}

export const changePwd = (params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/accounts/pwd`, params);
}
export const getOpenApiClientList = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/openapi`, {params});
}
export const addOpenApiClient = (params: any): Promise<any> => {

  return AxiosInstance.post(`${API_URL}/openapi`, params);
}
export const updateOpenApiClientStatus = (params:any): Promise<any> => {

  return AxiosInstance.put(`${API_URL}/openapi`,params);
}
export const deleteOpenApiClient = (id: any): Promise<any> => {

  return AxiosInstance.delete(`${API_URL}/openapi/${id}`);
}

export const resetOpenApiClient = (id: any): Promise<any> => {

  return AxiosInstance.post(`${API_URL}/openapi/${id}/reset`);
}

export const getLdapList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/systemIntegrations/ldaps`, { params });
}
export const addOrUpdateLdap = (params: any): Promise<any> => {

  return AxiosInstance.put(`${API_URL}/systemIntegrations/ldaps`, params);
}

export const deleteLdap = (id: any): Promise<any> => {

  return AxiosInstance.delete(`${API_URL}/systemIntegrations/ldaps/${id}`);
}

export const syncLdapUsers = (id: any): Promise<any> => {

  return AxiosInstance.post(`${API_URL}/systemIntegrations/ldaps/${id}/sync`);
}

export const getFeishuList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/systemIntegrations/feishus`, { params });
}
export const addOrUpdateFeishu = (params: any): Promise<any> => {

  return AxiosInstance.put(`${API_URL}/systemIntegrations/feishus`, params);
}

export const deleteFeishu = (id: any): Promise<any> => {

  return AxiosInstance.delete(`${API_URL}/systemIntegrations/feishus/${id}`);
}

export const syncFeishuUsers = (id: any): Promise<any> => {

  return AxiosInstance.post(`${API_URL}/systemIntegrations/feishus/${id}/sync`);
}